const ThreeCol = ({ children }) => (
  <div className="grid grid-cols-1 gap-x-4 lg:gap-x-10 gap-y-4  lg:gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
    {children}
  </div>
);
export default ThreeCol;
